export default (query) => {
  if (!query || !query.definitions) return false
  return query
    .definitions
    .find(({operation}) => operation === 'query')
    .selectionSet.selections[0].name.value
}
